import { render } from "./stackedChart.vue?vue&type=template&id=06185fce"
import script from "./stackedChart.vue?vue&type=script&lang=js"
export * from "./stackedChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__